/**
 * Brutalist Theme — Cart Drawer AJAX
 * Handles quantity changes and cart updates without page reload
 */

(function () {
  'use strict';

  function initCartDrawer() {
    const cartItemsContainer = document.querySelector('[data-cart-items]');
    if (!cartItemsContainer) return;

    // Delegate click events for quantity buttons
    cartItemsContainer.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-qty-change]');
      if (!btn) return;

      e.preventDefault();

      const key = btn.dataset.key;
      const qty = parseInt(btn.dataset.qty);
      const itemEl = btn.closest('[data-cart-item]');
      const qtyContainer = btn.closest('.cart-drawer__item-qty');

      // Disable buttons during update
      if (qtyContainer) {
        qtyContainer.querySelectorAll('button').forEach(b => b.disabled = true);
        qtyContainer.style.opacity = '0.4';
      } else {
        btn.disabled = true;
        btn.style.opacity = '0.4';
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty }),
        });

        if (!response.ok) throw new Error('Cart update failed');

        const cart = await response.json();

        if (qty === 0) {
          // Remove item with animation
          itemEl.style.transition = 'opacity 0.3s ease, max-height 0.4s ease, padding 0.4s ease';
          itemEl.style.opacity = '0';
          itemEl.style.maxHeight = '0';
          itemEl.style.overflow = 'hidden';
          itemEl.style.padding = '0';
          itemEl.style.margin = '0';
          setTimeout(() => {
            itemEl.remove();
            if (cart.item_count === 0) {
              showEmptyCart();
            }
          }, 400);
        } else if (qtyContainer) {
          // Check if at max stock
          const maxQty = parseInt(qtyContainer.dataset.maxQty) || 99999;
          const isTracked = qtyContainer.dataset.tracked === 'true';

          if (isTracked && qty >= maxQty) {
            // Replace qty controls with remove button
            const removeBtn = document.createElement('button');
            removeBtn.className = 'cart-drawer__remove-btn';
            removeBtn.setAttribute('data-qty-change', '');
            removeBtn.setAttribute('data-key', key);
            removeBtn.setAttribute('data-qty', '0');
            removeBtn.setAttribute('aria-label', 'Entfernen');
            removeBtn.innerHTML = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg> Entfernen';
            qtyContainer.replaceWith(removeBtn);
          } else {
            // Update quantity display
            const qtySpan = qtyContainer.querySelector('span');
            if (qtySpan) qtySpan.textContent = qty;

            // Update +/- data attributes
            const minusBtn = qtyContainer.querySelector('button:first-child');
            const plusBtn = qtyContainer.querySelector('button:last-child');
            if (minusBtn) minusBtn.dataset.qty = qty - 1;
            if (plusBtn) plusBtn.dataset.qty = qty + 1;

            // Disable + if next qty exceeds max, re-enable rest
            qtyContainer.querySelectorAll('button').forEach(b => {
              if (b === plusBtn && isTracked && qty + 1 > maxQty) {
                b.disabled = true;
              } else {
                b.disabled = false;
              }
            });
            qtyContainer.style.opacity = '1';
          }

          // Update item price
          const cartItem = cart.items.find(item => item.key === key);
          if (cartItem) {
            const priceEl = itemEl.querySelector('.cart-drawer__item-price');
            if (priceEl) priceEl.textContent = formatMoney(cartItem.final_line_price);
          }
        }

        // Update cart count everywhere
        updateCartCounts(cart.item_count);

        // Update subtotal
        const subtotalEl = document.querySelector('[data-cart-subtotal]');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

        // Update drawer title
        const titleEl = document.querySelector('.cart-drawer__title');
        if (titleEl) titleEl.textContent = 'Warenkorb (' + cart.item_count + ')';

        // Update free shipping progress bar
        updateShippingBar(cart.total_price);

        // Update product page ATC button if on product page
        if (typeof window.checkCartForVariant === 'function') {
          window.checkCartForVariant(cart);
        }

      } catch (err) {
        console.error('Cart update error:', err);
        if (qtyContainer) {
          qtyContainer.querySelectorAll('button').forEach(b => b.disabled = false);
          qtyContainer.style.opacity = '1';
        }
      }
    });
  }

  function showEmptyCart() {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    // Remove items container, footer and shipping bar
    const items = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('.cart-drawer__footer');
    const shippingBar = drawer.querySelector('[data-shipping-bar]');
    if (items) items.remove();
    if (footer) footer.remove();
    if (shippingBar) shippingBar.remove();

    // Update title
    const titleEl = drawer.querySelector('.cart-drawer__title');
    if (titleEl) titleEl.textContent = 'Warenkorb (0)';

    // Create empty state
    const emptyDiv = document.createElement('div');
    emptyDiv.className = 'cart-drawer__empty';
    emptyDiv.innerHTML = `
      <p class="cart-drawer__empty-text">Dein Warenkorb ist leer</p>
      <a href="/collections/all" class="btn">
        Weiter shoppen
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 12h15m0 0l-6.75-6.75M19.5 12l-6.75 6.75"/></svg>
      </a>
    `;

    // Insert after header
    const header = drawer.querySelector('.cart-drawer__header');
    if (header) {
      header.after(emptyDiv);
    } else {
      drawer.appendChild(emptyDiv);
    }
  }

  function updateCartCounts(count) {
    // Update badge-style counts
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
    });
    // Update text-style counts like "Bag (2)"
    document.querySelectorAll('[data-cart-count-text]').forEach(el => {
      el.textContent = '(' + count + ')';
    });
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€' + amount;
  }

  // Free Shipping Progress Bar update
  const FREE_SHIPPING_THRESHOLD = 10000; // 100€ in cents

  function updateShippingBar(cartTotal) {
    const shippingBar = document.querySelector('[data-shipping-bar]');
    if (!shippingBar) return;

    const remaining = FREE_SHIPPING_THRESHOLD - cartTotal;
    const progressPercent = Math.min(100, (cartTotal / FREE_SHIPPING_THRESHOLD) * 100);

    const textEl = shippingBar.querySelector('.cart-drawer__shipping-text');
    const progressEl = shippingBar.querySelector('.cart-drawer__shipping-progress');

    if (textEl) {
      if (remaining > 0) {
        textEl.className = 'cart-drawer__shipping-text';
        textEl.innerHTML = 'Noch <strong>' + formatMoney(remaining) + '</strong> bis zum kostenlosen Versand';
      } else {
        textEl.className = 'cart-drawer__shipping-text cart-drawer__shipping-text--free';
        textEl.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg> Kostenloser Versand freigeschaltet!';
      }
    }

    if (progressEl) {
      progressEl.style.width = progressPercent + '%';
    }
  }

  // Remove item buttons (if any exist)
  function initRemoveButtons() {
    document.querySelectorAll('[data-cart-remove]').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        const key = btn.dataset.key;
        const itemEl = btn.closest('[data-cart-item]');

        try {
          const response = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });

          if (response.ok) {
            const cart = await response.json();

            itemEl.style.transition = 'opacity 0.3s ease';
            itemEl.style.opacity = '0';
            setTimeout(() => {
              itemEl.remove();
              updateCartCounts(cart.item_count);

              const subtotalEl = document.querySelector('[data-cart-subtotal]');
              if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

              const titleEl = document.querySelector('.cart-drawer__title');
              if (titleEl) titleEl.textContent = 'Warenkorb (' + cart.item_count + ')';

              // Update free shipping progress bar
              updateShippingBar(cart.total_price);

              if (cart.item_count === 0) {
                showEmptyCart();
              }
            }, 300);
          }
        } catch (err) {
          console.error('Remove error:', err);
        }
      });
    });
  }

  // Expose init globally so theme.js can re-initialize after refreshing drawer HTML
  window.initCartDrawerListeners = function () {
    initCartDrawer();
    initRemoveButtons();
  };

  // Initialize on first load
  window.initCartDrawerListeners();
})();
